import api, { apiData } from "../utils/api";
import { serviceError } from "../lib/serviceError";
import { utmSourceURL } from "../lib/script";
import { getLeadID } from "../utils/storage";

class ServicesAPI {
  // Enter Mobile Number
  async enterMobileNumber(mobile) {
    try {
      const req = {
        url: "/customers/customer-login-byMsg91" + utmSourceURL(),
        method: "POST",
        data: {
          mobile,
        },
      };
      const res = await apiData(req);
      return res;
    } catch (error) {
      return error;
    }
  }

  // Enter Mobile Number
  async verifyOTPAPI(mobile, otp, consent, whatsapp_consent) {
    try {
      const req = {
        url: "/customers/verify-otp",
        method: "POST",
        data: {
          mobile,
          otp,
          consent,
          whatsapp_consent,
        },
      };

      const res = await apiData(req);
      return res;
    } catch (error) {
      return error;
    }
  }

  // Auto Login
  async autoLoginAPI(token) {
    try {
      const req = {
        url: "/customers/auto-login",
        method: "POST",
        data: {
          jwt_token: token,
        },
      };

      const res = await apiData(req);
      return res;
    } catch (error) {
      serviceError(error);
    }
  }

  // Redirection
  async redirectionAPI(session) {
    try {
      const req = {
        url: `/customers/getCustomerJourney/${session}`,
        method: "GET",
        data: {},
      };

      const res = await apiData(req);
      return res;
    } catch (error) {
      serviceError(error);
    }
  }

  // Dashboard API
  async dashboardAPI() {
    try {
      const req = {
        url: "/customers/dashboard",
        method: "POST",
        data: {
          appVersion: "28.2",
          residenceAddress: "H Block",
          state: "Delhi",
          city: "New Delhi",
          pincode: "110022",
        },
      };
      const res = await apiData(req);
      return res;
    } catch (error) {
      serviceError(error);
    }
  }

  // Enter User Name & Email
  // async enterUserNameEmail(name, email) {
  //   try {
  //     const endpoint = "/customer_onboarding/onboard_user_NameAndEmail";
  //     const req = {
  //       leadID: Number(localStorage.getItem("leadID")),
  //       name: name,
  //       email: email,
  //     };

  //     const { data } = await api.post(endpoint, req);
  //     return data;
  //   } catch (error) {
  //     serviceError(error);
  //   }
  // }

  async enterUserNameEmail(email) {
    try {
      const endpoint = "/customer_onboarding/onboardUserEmail";
      const req = {
        leadID: Number(localStorage.getItem("leadID")),
        email: email,
      };

      const { data } = await api.post(endpoint, req);
      return data;
    } catch (error) {
      serviceError(error);
    }
  }

  // PAN Verification
  async panVerification(pan, pinCode) {
    try {
      const req = {
        url: "/customer_onboarding/pan-verification",
        method: "POST",
        data: {
          panNumber: pan.toUpperCase(),
          pinCode: pinCode,
        },
      };

      const res = await apiData(req);

      return res;
    } catch (error) {
      serviceError(error);
    }
  }

  // PAN Confirmation
  async panConfirmation(pan) {
    try {
      const endpoint = "/customer_onboarding/pan-confirmation";
      const req = {
        panNumber: pan,
      };

      const { data } = await api.post(endpoint, req);
      return data;
    } catch (error) {
      serviceError(error);
    }
  }

  // Check Aadhaar Status
  async checkAadhaarStatusAPI() {
    try {
      const endpoint = "/common/aadhar-status";
      const req = {};

      const { data } = await api.get(endpoint, req);
      return data;
    } catch (error) {
      serviceError(error);
    }
  }

  // KYC Feature
  async getKycFeaturesAPI() {
    try {
      const endpoint = "/customers/kyc-feature";
      const req = {
        leadID: Number(localStorage.getItem("leadID")),
      };

      const { data } = await api.post(endpoint, req);
      return data;
    } catch (error) {
      serviceError(error);
    }
  }

  // Generate Aadhaar OTP
  async generateAadhaarOTP(aadhaar, accountID) {
    try {
      const req = {
        url: "/customer_onboarding/aadhar-verification-generate-otp",
        method: "POST",
        data: {
          leadID: Number(localStorage.getItem("leadID")),
          aadharNo: aadhaar,
          accountID,
        },
      };

      const res = await apiData(req);

      return res;
    } catch (error) {
      serviceError(error);
    }
  }

  // Aadhaar Verification OTP
  async aadhaarVerificationOTP(aadhaar, otp) {
    try {
      const endpoint = "/customer_onboarding/aadhar-verification-verify-otp";
      const req = {
        leadID: Number(localStorage.getItem("leadID")),
        aadharNo: aadhaar,
        otp: otp,
      };

      const { data } = await api.post(endpoint, req);
      return data;
    } catch (error) {
      serviceError(error);
    }
  }

  // Aadhaar PAN Verify
  async aadhaarPANVerify(accountID, aadharNo = "") {
    const req = {
      url: `/customer_onboarding/aadhar-pan-verify?leadID=${Number(localStorage.getItem("leadID"))}&accountID=${accountID}${aadharNo ? `&aadharNo=${aadharNo}` : ""}`,
      method: "GET",
      data: {},
    };
    const res = await apiData(req);
    return res;
  }

  // Re-kyc Button Message
  async rekycButtonMessages() {
    const req = {
      url: "/customers/rekycButtonMessages",
      method: "GET",
      data: {},
    };
    const res = await apiData(req);
    return res;
  }

  // PAN Aadhaar Mismatch
  async panAadhaarMismatchClick() {
    const req = {
      url: "/customers/pan-aadhar-mismatch-click",
      method: "GET",
      data: {},
    };
    const res = await apiData(req);
    return res;
  }

  async aadhaarPanReverify() {
    const req = {
      url: "/customer_onboarding/aadhar-pan-reverify",
      method: "GET",
      data: {},
    };
    const res = await apiData(req);
    return res;
  }

  // Aadhaar Verification Digilocker
  async aadhaarVerificationInitiateDigilocker(accountID) {
    const host = window.location.href.split("/");

    try {
      const endpoint = `/customer_onboarding/aadhar-verification-initiate-digilocker?leadID=${getLeadID()}&accountID=${accountID}`;
      // const endpoint = "/customer_onboarding/aadhar-uistreams";
      const req = {
        callBackUrl: host[0] + "//" + host[2] + "/digilocker-verify",
      };

      const { data } = await api.post(endpoint, req);
      return data;
    } catch (error) {
      serviceError(error);
    }
  }

  // Aadhaar Verification Webhook Digilocker
  async aadhaarVerificationWebhookDigilocker(params) {
    try {
      const endpoint = `/customer_onboarding/aadhar-verification-webhook-digilocker?code=${params?.code}&state=${params?.state}&leadID=${getLeadID()}`;
      const req = {};

      const { data } = await api.get(endpoint, req);
      return data;
    } catch (error) {
      serviceError(error);
    }
  }

  // Add Company & Income
  async addCompanyAndIncome(values) {
    try {
      const endpoint = "customers/incompleteDetailsUpdate";
      const req = {
        companyName: values.companyName,
        monthlyIncome: values.monthlyIncome,
        leadID: Number(localStorage.getItem("leadID")),
      };

      const { data } = await api.put(endpoint, req);
      return data;
    } catch (error) {
      serviceError(error);
    }
  }

  // Incomplete Details Update
  async incompleteDetailsUpdate(data, repeatCustomer = false) {
    const { key, value, monthlyIncomeConsent } = data;
    const host = window.location.href.split("/");

    try {
      const endpoint = "/customers/incompleteDetailsUpdate";
      const req = {
        [key]: value,
        leadID: Number(localStorage.getItem("leadID")),
        finboxCallBackUrl: host[0] + "//" + host[2] + "/finbox",
        repeat: repeatCustomer,
        ...(monthlyIncomeConsent && { monthlyIncomeConsent }),
      };
      const { data } = await api.put(endpoint, req);
      return data;
    } catch (error) {
      if (error.response?.data) {
        return error.response.data;
      }
      serviceError(error);
    }
  }

  // Enter Your Residence
  async enterYourResidence(data) {
    const { key, value } = data;
    try {
      const req = {
        url: "/customers/incompleteDetailsUpdate",
        method: "PUT",
        data: {
          [key]: value,
          leadID: Number(localStorage.getItem("leadID")),
        },
      };
      const res = await apiData(req);
      return res;
    } catch (error) {
      console.log("Error:", error);
    }
  }

  // Current Address
  async currentAddressUpdate(values, repeatCustomer) {
    const { houseNo, city, state, pinCode, landmark } = values;

    const host = window.location.href.split("/");

    try {
      const endpoint = "/customers/incompleteDetailsUpdate";
      const req = {
        residenceAddress: `${houseNo} ${city} ${state} ${pinCode}`,
        state: state,
        city: city,
        pincode: `${pinCode}`,
        landmark: landmark,
        leadID: Number(localStorage.getItem("leadID")),
        finboxCallBackUrl: host[0] + "//" + host[2] + "/finbox",
        repeat: repeatCustomer,
      };

      const { data } = await api.put(endpoint, req);
      return data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
      serviceError(error);
    }
  }

  // Get States
  async getStates(value) {
    try {
      const endpoint = `/customer_onboarding/getStates?searchWord=${value.toLowerCase()}`;
      const req = {};
      const { data } = await api.get(endpoint, req);
      return data;
    } catch (error) {
      serviceError(error);
    }
  }

  // Get Address
  async getAddressAPI() {
    try {
      const endpoint = "/customers/address";
      const req = {};
      const { data } = await api.get(endpoint, req);
      return data;
    } catch (error) {
      serviceError(error);
    }
  }

  // Add Father Name
  async addFatherNameAPI(name) {
    try {
      const endpoint = "customers/father-name";
      const req = {
        fatherName: name,
      };
      const { data } = await api.post(endpoint, req);
      return data;
    } catch (error) {
      serviceError(error);
    }
  }
}

export default ServicesAPI;
